/**
 * 从当前页面的 URL 查询参数中获取指定参数名的值
 * ==================== 使用示例 ==================== *
 * URL: https://example.com/?name=张三&age=25&status=&token=abc123 *
 * getQueryValue('name');    // "张三"
 *
 * TODO: 后续可考虑使用 URLSearchParams 替代该函数
 * @param key 要获取的参数名
 * @returns string | null
 */
export function getQueryValue(key: string): string | null {
    if (typeof window === 'undefined') {
        return null;
    }

    if (!key) {
        return null;
    }
    const queryString = window.location.search;
    if (!queryString || queryString === '?') {
        return null;
    }

    // 将 query 字符串转为键值对数组（只用 split + map，不用循环）
    const pairs = queryString
        .substring(1) // 去掉开头的 ?
        .split('&') // 分割成 ["k1=v1", "k2=v2", ...]
        .filter(Boolean); // 过滤掉空字符串（如 && 情况）

    // 使用 .find() 查找第一个匹配的 key（数组迭代方法，符合规则）
    const targetPair = pairs.find(pair => {
        const equalIndex = pair.indexOf('=');
        const rawKey = equalIndex > -1 ? pair.substring(0, equalIndex) : pair;

        let decodedKey: string;
        try {
            decodedKey = decodeURIComponent(rawKey.replace(/\+/g, ' '));
        } catch {
            decodedKey = rawKey;
        }

        return decodedKey === key;
    });

    // 如果没找到，直接返回 null
    if (!targetPair) {
        return null;
    }

    // 提取值部分
    const equalIndex = targetPair.indexOf('=');
    const rawValue = equalIndex > -1 ? targetPair.substring(equalIndex + 1) : '';

    try {
        return decodeURIComponent(rawValue.replace(/\+/g, ' '));
    } catch {
        return rawValue; // 解码失败时返回原始值
    }
}
